import type { RouteObject } from 'react-router';

import { PeoplePage } from './People';

/**
 * `/people` — one `RouteObject`, so the file is `.route.tsx` singular.
 *
 * It sits inside the console layout route, which already runs the guard chain,
 * so it adds no loader of its own. The guard decides **navigation**; every read
 * and every write on this surface is authorized by `backend-content` on the
 * request itself.
 */
export const peopleRoute: RouteObject = {
  path: '/people',
  element: <PeoplePage />,
};
